import React from "react";
import { StyleSheet, ImageBackground, View } from "react-native";
import Modal from 'theme/Modal';
import { colorList } from 'utils/colors'
import * as Progress from 'react-native-progress';
import { LoadingStyles, LoadingStylesSizeL, LoadingStylesSizeS, LoadingStylesSizeXS } from 'styles/components/atoms/Loading'
import backgroundImage from 'assets/icon_big_gradient.png';
import { ThemedShared } from 'styles/themed'
import { TESTID } from '_shared/config/testID'
import isEqual from 'react-fast-compare'
import HelperStyles from 'utils/HelperStyles'

const LoadingComponent = ({ progress = null, size = 'm', label = null, containerStyle = {}, fullscreen = false, testID = null }) => {
	
	if( testID === null ){
		testID = TESTID.INTERFACE.LOADING_INDICATOR.DEFAULT;
	}
	
	let spinnerContainerStyles = [ LoadingStyles.spinnerContainer ];
	let spinnerOuterStyle = LoadingStyles.spinnerOuter;
	let spinnerInnerStyle = LoadingStyles.spinnerInner;
	
	switch( size ) {
		case 'xs':
			spinnerContainerStyles.push( LoadingStylesSizeXS.spinnerContainer );
			spinnerOuterStyle = LoadingStylesSizeXS.spinnerOuter;
			spinnerInnerStyle = LoadingStylesSizeXS.spinnerInner;
			break;
			
		case 's':
			spinnerContainerStyles.push( LoadingStylesSizeS.spinnerContainer );
			spinnerOuterStyle = LoadingStylesSizeS.spinnerOuter;
			spinnerInnerStyle = LoadingStylesSizeS.spinnerInner;
			break;
			
		case 'l':
			spinnerContainerStyles.push( LoadingStylesSizeL.spinnerContainer );
			spinnerOuterStyle = LoadingStylesSizeL.spinnerOuter;
			spinnerInnerStyle = LoadingStylesSizeL.spinnerInner;
			break;
	}
	
	spinnerOuterStyle = (StyleSheet.flatten( spinnerOuterStyle ) ?? {})
	spinnerInnerStyle = (StyleSheet.flatten( spinnerInnerStyle ) ?? {})
	
	const spinnerContainerStyle = spinnerContainerStyles
	
	const loaderStyle = [
		LoadingStyles.container,
		containerStyle
	]
	
	const spinnerOpacityStyle = [
		LoadingStyles.spinner,
		LoadingStyles.spinnerOpacity,
	]
	
	const spinnerSize = HelperStyles.toObject( spinnerOuterStyle )?.width;
	const spinnerThickness = HelperStyles.toObject( spinnerOuterStyle )?.borderWidth;
	
	const loader = (
		<View
			style={ loaderStyle }
			testID={ testID }>
	
			<View
				style={ spinnerContainerStyle }>
				
				<ImageBackground
					source={ backgroundImage }
					resizeMode={ 'cover' }
					style={ LoadingStyles.spinnerBackground}>
					
					<View
						style={ LoadingStyles.spinner }>
						
						<Progress.CircleSnail
							color={ colorList.WHITE.primary }
							size={ spinnerInnerStyle.width }
							spinDuration={ 4000 }
							thickness={ spinnerInnerStyle.borderWidth }
						/>
					</View>
					
					<Choose>
						<When condition={ progress === null }>
							<View
								style={ LoadingStyles.spinner }>
								
								<Progress.CircleSnail
									color={ colorList.GREY.primary }
									size={ spinnerSize }
									thickness={ spinnerThickness }
								/>
							</View>
						</When>
						<Otherwise>
							<View
								style={ spinnerOpacityStyle }>
								
								<Progress.CircleSnail
									color={ colorList.WHITE.primary }
									size={ spinnerSize }
									thickness={ spinnerThickness }
								/>
							</View>
							
							<View
								style={ LoadingStyles.spinner}>
								
								<Progress.Circle
									fill="transparent"
									color={ colorList.WHITE.primary }
									size={ spinnerSize - 4 }
									thickness={ spinnerThickness }
									progress={ progress }
									borderWidth={ 0 }
									direction="counter-clockwise"
								/>
							</View>
						</Otherwise>
					</Choose>
				</ImageBackground>
			</View>
		</View>
	);
	
	if( fullscreen ){
		return (
			<Modal
				visible={ true }
				modalStyle={ LoadingStyles.fullscreen }
				backdropStyle={ ThemedShared.backdrop }>
				
				{ loader }
			</Modal>
		)
	}
	
	return loader;
}

export default React.memo( LoadingComponent, isEqual );
